// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AccountForgotPasswordRouteImport } from './routes/account/forgot-password'
import { Route as AccountLoginRouteImport } from './routes/account/login'
import { Route as AccountOrdersRouteImport } from './routes/account/orders'
import { Route as AccountRegisterRouteImport } from './routes/account/register'
import { Route as AccountResetPasswordRouteImport } from './routes/account/reset-password'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminBannersRouteImport } from './routes/admin/banners'
import { Route as AdminCategoriesRouteImport } from './routes/admin/categories'
import { Route as AdminCmsRouteImport } from './routes/admin/cms'
import { Route as AdminCustomersRouteImport } from './routes/admin/customers'
import { Route as AdminInventoryRouteImport } from './routes/admin/inventory'
import { Route as AdminOrdersRouteImport } from './routes/admin/orders'
import { Route as AdminPaymentsRouteImport } from './routes/admin/payments'
import { Route as AdminProductsRouteImport } from './routes/admin/products'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminReviewsRouteImport } from './routes/admin/reviews'
import { Route as AdminSecurityRouteImport } from './routes/admin/security'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminShippingRouteImport } from './routes/admin/shipping'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as CollectionsIndexRouteImport } from './routes/collections/index'
import { Route as CollectionsSlugRouteImport } from './routes/collections/$slug'
import { Route as ProductIdRouteImport } from './routes/product.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const OrdersRoute = OrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ShippingRoute = ShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => rootRouteImport
          })
const AccountForgotPasswordRoute = AccountForgotPasswordRouteImport.update({
            id: '/account/forgot-password',path: '/account/forgot-password',getParentRoute: () => rootRouteImport
          })
const AccountLoginRoute = AccountLoginRouteImport.update({
            id: '/account/login',path: '/account/login',getParentRoute: () => rootRouteImport
          })
const AccountOrdersRoute = AccountOrdersRouteImport.update({
            id: '/account/orders',path: '/account/orders',getParentRoute: () => rootRouteImport
          })
const AccountRegisterRoute = AccountRegisterRouteImport.update({
            id: '/account/register',path: '/account/register',getParentRoute: () => rootRouteImport
          })
const AccountResetPasswordRoute = AccountResetPasswordRouteImport.update({
            id: '/account/reset-password',path: '/account/reset-password',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminBannersRoute = AdminBannersRouteImport.update({
            id: '/banners',path: '/banners',getParentRoute: () => AdminRoute
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminRoute
          })
const AdminCmsRoute = AdminCmsRouteImport.update({
            id: '/cms',path: '/cms',getParentRoute: () => AdminRoute
          })
const AdminCustomersRoute = AdminCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => AdminRoute
          })
const AdminInventoryRoute = AdminInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => AdminRoute
          })
const AdminOrdersRoute = AdminOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AdminRoute
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AdminRoute
          })
const AdminProductsRoute = AdminProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AdminRoute
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AdminRoute
          })
const AdminReviewsRoute = AdminReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => AdminRoute
          })
const AdminSecurityRoute = AdminSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminShippingRoute = AdminShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
            id: '/collections/',path: '/collections/',getParentRoute: () => rootRouteImport
          })
const CollectionsSlugRoute = CollectionsSlugRouteImport.update({
            id: '/collections/$slug',path: '/collections/$slug',getParentRoute: () => rootRouteImport
          })
const ProductIdRoute = ProductIdRouteImport.update({
            id: '/product/$id',path: '/product/$id',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminBannersRoute: AdminBannersRoute,AdminCategoriesRoute: AdminCategoriesRoute,AdminCmsRoute: AdminCmsRoute,AdminCustomersRoute: AdminCustomersRoute,AdminInventoryRoute: AdminInventoryRoute,AdminOrdersRoute: AdminOrdersRoute,AdminPaymentsRoute: AdminPaymentsRoute,AdminProductsRoute: AdminProductsRoute,AdminReportsRoute: AdminReportsRoute,AdminReviewsRoute: AdminReviewsRoute,AdminSecurityRoute: AdminSecurityRoute,AdminSettingsRoute: AdminSettingsRoute,AdminShippingRoute: AdminShippingRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,OrdersRoute: OrdersRoute,PrivacyRoute: PrivacyRoute,ShippingRoute: ShippingRoute,ShopRoute: ShopRoute,TermsRoute: TermsRoute,AccountForgotPasswordRoute: AccountForgotPasswordRoute,AccountLoginRoute: AccountLoginRoute,AccountOrdersRoute: AccountOrdersRoute,AccountRegisterRoute: AccountRegisterRoute,AccountResetPasswordRoute: AccountResetPasswordRoute,BlogSlugRoute: BlogSlugRoute,CollectionsSlugRoute: CollectionsSlugRoute,ProductIdRoute: ProductIdRoute,AccountIndexRoute: AccountIndexRoute,BlogIndexRoute: BlogIndexRoute,CollectionsIndexRoute: CollectionsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)